// to-do: join all these metafield constants into one w/ formatted objects
// this is ugly

export const MetafieldsReadableKeys = {
  key_benefits: 'Key Benefits',
  how_it_helps: 'How it Helps',
  how_it_works: 'How it Works',
  additional_info: 'Additional Info',
  ingredients: 'Ingredients',
  feeding_guide: 'Feeding Guide',
  avg_nutrient_caloric_content: 'Average Nutrient Caloric Content',
};

export const MetafieldsKeys = {
  KEY_BENEFITS: 'key_benefits',
  HOW_IT_HELPS: 'how_it_helps',
  HOW_IT_WORKS: 'how_it_works',
  ADDITIONAL_INFO: 'additional_info',
  INGREDIENTS: 'ingredients',
  FEEDING_GUIDE: 'feeding_guide',
  AVG_NUTRIENT_CALORIC_CONTENT: 'avg_nutrient_caloric_content',
  DISCOUNTED_PRICE: 'discounted_price',
  FULL_PRICE: 'full_price',
};

export const VariantfieldsKeys = {
  COMPARE_AT_PRICE: 'compare_at_price',
  PRICE: 'price',
};

export const MetafieldOrder = [
  MetafieldsKeys.DETAILS,
  MetafieldsKeys.CHARACTERISTICS,
  MetafieldsKeys.BENEFITS,
  MetafieldsKeys.INDICATIONS_AND_USAGE,
  MetafieldsKeys.INFORMATION,
  MetafieldsKeys.SAFETY_INFO,
  MetafieldsKeys.FAQ,
  MetafieldsKeys.EDUCATIONAL_MATERIALS,
];

export const ProductsSortingOptions = [
  { value: 'published_at desc', label: 'Newest Added', default: true },
  { value: 'price asc', label: 'Price Low to High' },
  { value: 'price desc', label: 'Price High to Low' },
];

export const TopCategories = [
  'all-products',
  'dog-food',
  'cat-food',
  'fontpage',
  'prescription-diet',
  'science-diet',
  'treats',
];
